import AnimationPage from "../Animation/AnimationPage.js";
import "../style.css";
import "../auth.css";
import React, { useState, useRef} from "react";
import Cookies from "universal-cookie";
import { API_URL } from "../../api";

const RegisterPage = () => {
	let url = "";
	const [type, setType] = useState("password");
	const [log, setLog] = useState(" ");

	const [loading, setLoading] = useState(false);
	const [disabled, setDisabled] = useState(false);

	const [setUsername] = useState(" ");
	const [setPassword] = useState(" ");
	const [setEmail] = useState(" ");
	const [status, setStatus] = useState(false);

	let UserInput = useRef(null);
	let PasswordInput = useRef(null);
	let EmailInput = useRef(null);

	const ToggleText = () => {
		setType((prevType) => (prevType === "password" ? "text" : "password"));
	};

	const GetData = (username, password) => {
		url = `${API_URL}/api/GetData?username=${encodeURIComponent(
			username
		)}&password=${encodeURIComponent(password)}`;

		fetch(url)
			.then((response) => response.json())
			.then((data) => {
				console.log(data.status);
				setLog(data.message);
				window.location.reload();
			})
			.catch((error) => {
				setLog(error);
			});
	};

	const GetLogin = () => {
		const cookies = new Cookies();
		cookies.set("sessionToken", "logout", { path: "/" });
		window.location.reload();
	};

	const RegisterDB = (username, password, email) => {
		setDisabled(true);
		setLoading(true);
		url = `${API_URL}/api/register?username=${encodeURIComponent(
			username
		)}&password=${encodeURIComponent(password)}&email=${encodeURIComponent(
			email
		)}`;

		fetch(url)
			.then((response) => response.json())
			.then((data) => {
				setLog(data.message);
				setStatus(data.status);
				const cookies = new Cookies();
				cookies.set("sessionToken", data.sessionToken, { path: "/" });

				if (data.status === true) {
					GetData(username, password);
				} else {
					setDisabled(false);
					setLoading(false);
				}
			})
			.catch((error) => {
				setLog(error);
			});
	};

	const RegisterUser = (event) => {
		event.preventDefault();

		const username = UserInput.current.value;
		const password = PasswordInput.current.value;
		const email = EmailInput.current.value;

		setUsername(username);
		setPassword(password);
		setEmail(email);

		RegisterDB(username, password, email);
		setDisabled(false);
	};

	return (
		<div>
			{status === true && (
				<div>
					<AnimationPage />
				</div>
			)}
			{status === false && (
				<div className="log-form" id="log-form">
					<form>
						<div className="blured"></div>
						<h2 className="prijava">Registracija</h2>
						<label for="username" className="label">
							Uporabniško ime
						</label>
						<span className="input_field">
							<input
								type="text"
								id="username"
								ref={UserInput}
								title="Uporabniško ime"
								placeholder="Kroky uporabniško ime"
							/>
						</span>
						<label for="password" className="label">
							Geslo
						</label>
						<span className="input_field">
							<input
								type={type}
								id="password"
								ref={PasswordInput}
								title="Geslo"
								autoComplete="current-password"
								placeholder="Kroky geslo"
							/>
							<button
								type="button"
								onClick={ToggleText}
								className="showpass">
								<a>
									<span class="material-symbols-outlined icons">
										{type === "password"
											? "visibility"
											: "visibility_off"}
									</span>
								</a>
							</button>
						</span>
						<label for="email" className="label">
							e-Pošta
						</label>
						<span className="input_field">
							<input
								ref={EmailInput}
								type="text"
								id="email"
								title="email"
								placeholder="e-Pošta"
							/>
						</span>
						<span>
							<p className="sporocilo">{log}</p>
						</span>
						<span className="buttons">
							<button
								onClick={RegisterUser}
								className={`btn ${loading ? "loading" : ""}`}
								id="submit"
								disabled={disabled}>
								Registracija
							</button>
							<a onClick={GetLogin} class="register">
								Prijava
							</a>
						</span>
					</form>
				</div>
			)}
		</div>
	);
};

export default RegisterPage;
